import logoof from "../../assets/logoof.png";
import logofs from "../../assets/logofs.png";
import main from "../../assets/main-bg.png";
import stats from "../../assets/stats.webp";

function ShortMain() {
    return ( 
        <>
            <div className="main-block short-main container">
                <div className="row">

                    <div className="col-12 col-md-12 col-lg-7 main-left-block">
                        <div className="short-image-container">
                          <img 
                            src={stats} 
                            alt="background" 
                            />
                        </div>
                    </div>

                    <div className="col-12 col-md-12 col-lg-5">
                        <h1 className="main-heading heading-reduced"><span class="on-color">Boost your OnlyFans Income</span> with OnlyGlance Leading Management Services</h1>
                        <ul className="benefits">
                            <li className="benefit">
                                Maximize earnings for pro content creators.
                            </li>
                            <li className="benefit">
                                We specialize in turning newcomers into top earners.
                            </li>
                            <li className="benefit">
                                Detailed onboarding for a flawless success. 
                            </li>
                            <li className="benefit">
                                Social media experts for every platform.
                            </li>
                            <li className="benefit">
                                Over 12+ trained chatters, ready to engage and build lasting online relationships. 
                            </li>
                            <li className="benefit">
                                Partnering with the worlds top models.
                            </li>
                        </ul>
                    </div>

                </div>
            </div>
        </>
     );
}

export default ShortMain;